export const getPropertyByPath = (object: any, pathToField: string) => {
  return pathToField
    .replace(/\[([^[\]]*)\]/g, '.$1.')
    .split('.')
    .filter((t) => t !== '')
    .reduce((prev, cur) => prev && prev[cur], object);
};
